var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1274_716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6141 29.9298L10.1738 50.1089C10.3921 50.8754 10.7845 51.5823 11.3208 52.1755C11.8571 52.7688 12.5232 53.2327 13.2683 53.5318C14.0133 53.831 14.8175 53.9573 15.6194 53.9013C16.4213 53.8453 17.1996 53.6084 17.8949 53.2087L39.7689 40.8661L29.6141 29.9298Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2716 26.4998L39.8126 21.132L29.1653 30.3888L39.8559 40.8372L49.2429 35.5269C50.0745 35.0955 50.771 34.4468 51.257 33.6511C51.743 32.8555 51.9999 31.9433 51.9999 31.0133C51.9999 30.0833 51.743 29.171 51.257 28.3754C50.771 27.5797 50.0745 26.9311 49.2429 26.4997L49.2716 26.4998Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.174 11.8177C10.0565 12.2481 9.99803 12.6922 10.0001 13.138V48.7884C10.0012 49.2341 10.0596 49.6778 10.174 50.1089L30.2806 30.4465L10.174 11.8177Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.759 30.9633L39.8124 21.1321L17.9675 8.73195C17.1455 8.25508 16.2108 8.00252 15.2583 8.00001C12.8946 7.99546 10.8166 9.54971 10.1738 11.8034L29.759 30.9633Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1274_716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 46,
    fill: "white",
    transform: "translate(10 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.34891950b13dc35d9fef865fc6de737f.svg";
export { ForwardRef as ReactComponent };